import { FoldersContainer } from "../../FolderPage/FoldersContainer/FoldersContainer";
import { useGetFolderByOrganisationId } from "../../../services/folderService";
import { useGetOrganisationById } from "../../../services/organisationService";

type Props = {
  organisationId?: string;
};

export const OrganisationDetailContainer = ({ organisationId }: Props) => {
  const { data: folders } = useGetFolderByOrganisationId(organisationId);
  const { data: organisation } = useGetOrganisationById(organisationId);

  return (
    <div className="mt-3">
      <h4 className="mb-5">{organisation ? organisation.name : ""}</h4>
      <FoldersContainer
        folders={folders || []}
        organisationId={organisationId}
      />
    </div>
  );
};
